<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h360_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <el-form
        ref="dialogAddEditViewForm"
        :model="dialogAddEditViewForm"
        :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            基础信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="名称"
                  prop="name"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.name"
                    maxlength="64"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="所属省区"
                  prop="provinceId"
                >
                  <el-select
                    v-if="eventType !== 'view'"
                    v-model="dialogAddEditViewForm.provinceId"
                    filterable
                    clearable
                    placeholder="请选择省区"
                    style="width:100%"
                    :disabled="eventType==='view'"
                    @change="changeProvinceFun"
                  >
                    <el-option
                      v-for="item in provinceOptions"
                      :key="item.label"
                      :label="item.label"
                      :value="item.data"
                    />
                  </el-select>
                  <el-input
                    v-else
                    v-model="dialogAddEditViewForm.provinceName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="所属城市"
                  prop="cityId"
                >
                  <el-select
                    v-if="eventType !== 'view'"
                    v-model="dialogAddEditViewForm.cityId"
                    filterable
                    clearable
                    placeholder="请选择城市"
                    style="width:100%"
                    :disabled="eventType==='view'"
                    @change="changeCityFun"
                  >
                    <el-option
                      v-for="item in cityOptions"
                      :key="item.label"
                      :label="item.label"
                      :value="item.data"
                    />
                  </el-select>
                  <el-input
                    v-else
                    v-model="dialogAddEditViewForm.cityName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="所属区县"
                  prop="countyId"
                >
                  <el-select
                    v-if="eventType !== 'view'"
                    v-model="dialogAddEditViewForm.countyId"
                    filterable
                    clearable
                    placeholder="请选择区县"
                    style="width:100%"
                    :disabled="eventType==='view'"
                    @change="changeCountyFun"
                  >
                    <el-option
                      v-for="item in countyOptions"
                      :key="item.label"
                      :label="item.label"
                      :value="item.data"
                    />
                  </el-select>
                  <el-input
                    v-else
                    v-model="dialogAddEditViewForm.countyName"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="modal-box">
          <h3 class="modal-title">
            备注信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item prop="remark">
                  <el-input
                    v-model="dialogAddEditViewForm.remark"
                    type="textarea"
                    placeholder="备注"
                    maxlength="128"
                    style="margin-top:10px;"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 区域API
import { listAreaApi } from '@/api/v2/area'
// 商圈API
import { viewBusinessDistrictSettingApi, saveBusinessDistrictSettingApi } from '@/api/v2/businessDistrictSetting'

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        provinceId: [{ required: true, message: '请选择所属省区', trigger: 'change' }],
        cityId: [{ required: true, message: '请选择所属城市', trigger: 'change' }],
        countyId: [{ required: true, message: '请选择所属区县', trigger: 'change' }],
        remark: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' }]
      },
      provinceOptions: [],
      cityOptions: [],
      countyOptions: []
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;
        _this.provinceOptions = []
        _this.cityOptions = []
        _this.countyOptions = []
        _this.dialogAddEditViewForm = {
          name: '',
          provinceId: '',
          provinceName: '',
          cityId: '',
          cityName: '',
          countyId: '',
          countyName: '',
          remark: ''
        }
        if (_this.eventType !== 'view') {
          _this.initProvinceSelectData();
        }
        if (_this.eventType !== 'add') {
          _this.loadBusinessDistrictData();
        }

        _this.$nextTick(() => {
          _this.$refs.dialogAddEditViewForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 加载数据
    loadBusinessDistrictData () {
      let _this = this;
      viewBusinessDistrictSettingApi({ id: _this.dataId }).then((response) => {
        const { data } = response
        for (let key in _this.dialogAddEditViewForm) {
          _this.dialogAddEditViewForm[key] = data[key]
        }
        _this.dialogAddEditViewForm.id = data.id
        if (_this.eventType !== 'view') {
          _this.initCitySelectData(data.provinceId)
          _this.initCountySelectData(data.cityId)
        }
      })
    },
    // 初始省区下拉数据
    initProvinceSelectData () {
      listAreaApi({ parentId: 1, isUserArea: 1 }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          this.provinceOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 选择省区回调
    changeProvinceFun (val) {
      let selectItem = {}
      selectItem = this.provinceOptions.find(item => {
        return item.data === val
      })
      this.dialogAddEditViewForm.provinceName = selectItem ? selectItem.label : ''
      this.cityOptions = []
      this.countyOptions = []
      this.dialogAddEditViewForm.cityName = ''
      this.dialogAddEditViewForm.cityId = null
      this.dialogAddEditViewForm.countyName = ''
      this.dialogAddEditViewForm.countyId = null
      this.initCitySelectData(val)
    },
    // 初始城市下拉数据
    initCitySelectData (val) {
      listAreaApi({ parentId: val, isUserArea: 1 }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          this.cityOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 选择城市回调
    changeCityFun (val) {
      let selectItem = {}
      selectItem = this.cityOptions.find(item => {
        return item.data === val
      })
      this.dialogAddEditViewForm.cityName = selectItem ? selectItem.label : ''
      this.countyOptions = []
      this.dialogAddEditViewForm.countyName = ''
      this.dialogAddEditViewForm.countyId = null
      this.initCountySelectData(val)
    },
    // 初始区县下拉数据
    initCountySelectData (val) {
      listAreaApi({ parentId: val, isUserArea: 1 }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          this.countyOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 选择区县回调
    changeCountyFun (val) {
      let selectItem = {}
      selectItem = this.countyOptions.find(item => {
        return item.data === val
      })
      this.dialogAddEditViewForm.countyName = selectItem ? selectItem.label : ''
    },
    modalClose () {
      let _this = this;
      _this.$emit('update:dialogVisible', false)
      _this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      let _this = this;
      _this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          _this.$confirm(
            (_this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '商圈', '系统提示',
            { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }
          ).then(async () => {
            saveBusinessDistrictSettingApi(this.dialogAddEditViewForm).then(() => {
              _this.$message({ message: '保存成功', type: 'success' })
              _this.$emit('reloadData')
              _this.modalClose()
            }).catch(() => { })
          }).catch(() => { })
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
</style>
